import React from 'react';

const line1 = `<script src=`;
const line1_2 = `"https://cdn.auth0.com/js/lock-10.0.min.js"`;
const line1_3 = `</script>`;
const line2 = `<script type=`;
const line2_2 = `"text/Javascript"`;
const line2_3 = `>`;
const line3 = `   var`;
const line3_2 = `lock =`;
const line3_3 = `new`;
const line3_4 = `Auth0Lock('4N28qGxpvbvu4xBdSbY2U7C70AJS4B29', 'matias);'`;
const line4 = `   function signIn`;
const line4_2 = `(){`;
const line5 = `       lock.show({`;
const line5_2 = `           callbackURL: ‘http://localhost:CHANGE-TO-YOUR-PORT,`;
const line5_3 = `           responseType: ‘code’,`;
const line5_4 = `           authParams: {`;
const line5_5 = `               scope: ‘openid profile’`;
const line5_6 = `           }`;
const line5_7 = `       });`;
const line6 = `    }`;
const line7 = `</script>`;
const line8 = `<button onClick=`;
const line8_2 = `"signIn()"`;
const line8_3 = `>`;
const line8_4 = `Login`;
const line8_5 = `</button>`;

const SdkPicker3 = ({ visibility }) =>
  <div className={`window-wrapper step-hidden-visibility ${visibility ? 'step-visibility' : ''}`}>
    <svg
      width="555"
      height="539"
      viewBox="0 0 555 539"
      className="sdk-picker-3"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMinYMin meet"
    >
      <defs>
        <rect id="path-1" width="555" height="539" />
      </defs>
      <g id="Page-1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(0 -41)">
          <g id="body" transform="translate(0 41)">
            <mask id="mask-2" fill="#fff">
              <use xlinkHref="#path-1" />
            </mask>
            <use id="Rectangle" fill="#F7F7F7" xlinkHref="#path-1" />
            <path
              d="M56.4356434,54.8802251 L53.4053728,45.5061147 L61.3374882,39.7141711 L51.5325397,39.7141711 L48.5019094,30.3404222 L48.5010102,30.3378918 L58.3075773,30.3378918 L61.3387471,39.7132674 L61.3387471,39.7130866 L61.3412648,39.7116407 C63.101879,45.1505912 61.2887521,51.3367376 56.4356434,54.8802251 L56.4356434,54.8802251 L56.4356434,54.8802251 Z M40.5678157,54.8802251 L40.565298,54.8820325 L48.4995715,60.6754221 L56.4356434,54.8804058 L48.5020892,49.0868355 L40.5678157,54.8802251 L40.5678157,54.8802251 L40.5678157,54.8802251 Z M35.6638128,39.7118214 L35.6638128,39.7118214 C33.8107619,45.445204 35.9618044,51.5203736 40.5661972,54.8813096 L40.5669166,54.8784176 L43.5975468,45.5048495 L35.6670499,39.7139903 L45.4696606,39.7139903 L48.5004707,30.3402415 L48.50119,30.3377111 L38.6940834,30.3377111 L35.6638128,39.7118214 L35.6638128,39.7118214 L35.6638128,39.7118214 Z"
              id="Shape"
              fill="#EB5424"
            />
            <path
              d="M35,93.0356473 L95,93.0356473"
              id="Line"
              stroke="#000"
              strokeWidth="4"
              opacity=".11"
              strokeLinecap="square"
            />
            <path
              d="M35,115.283302 L75,115.283302"
              id="Line"
              stroke="#000"
              strokeWidth="4"
              opacity=".11"
              strokeLinecap="square"
            />
            <path
              d="M35,137.530957 L85,137.530957"
              id="Line"
              stroke="#000"
              strokeWidth="4"
              opacity=".11"
              strokeLinecap="square"
            />
            <path
              d="M35,159.778612 L105,159.778612"
              id="Line"
              stroke="#000"
              strokeWidth="4"
              opacity=".11"
              strokeLinecap="square"
            />
            <path
              d="M35,182.026266 L75,182.026266"
              id="Line"
              stroke="#000"
              strokeWidth="4"
              opacity=".11"
              strokeLinecap="square"
            />
            <path
              d="M35,204.273921 L55,204.273921"
              id="Line"
              stroke="#000"
              strokeWidth="4"
              opacity=".11"
              strokeLinecap="square"
            />
            <text
              id="Quickstart"
              fontFamily="FaktPro-Medium, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
              fontSize="24"
              fontWeight="400"
              fill="#333"
            >
              <tspan x="145" y="101.908">Quickstart</tspan>
            </text>
            <g id="Group-9">
              <g transform="translate(145 72.81)">
                <g id="Default" transform="translate(233)">
                  <g className="animate-button">
                    <rect id="Rectangle-16" fill="#EB5424" width="147" height="34" rx="2" />
                    <path
                      d="M36.45144,16.97056 C36.45144,19.07386 37.77498,20.62312 39.9501,20.62312 C41.6943,20.62312 42.83316,19.66894 43.09992,18.17098 L41.72508,18.17098 C41.49936,18.99178 40.96584,19.44322 39.97062,19.44322 C38.69838,19.44322 37.86732,18.3967 37.86732,16.97056 C37.86732,15.51364 38.67786,14.4979 39.97062,14.4979 C40.90428,14.4979 41.49936,14.94934 41.72508,15.77014 L43.09992,15.77014 C42.83316,14.27218 41.71482,13.318 39.97062,13.318 C37.82628,13.318 36.45144,14.88778 36.45144,16.97056 Z M44.45082,16.97056 C44.45082,14.86726 45.8667,13.318 48.05208,13.318 C50.19642,13.318 51.64308,14.86726 51.64308,16.97056 C51.64308,19.07386 50.19642,20.62312 48.05208,20.62312 C45.8667,20.62312 44.45082,19.07386 44.45082,16.97056 Z M45.8667,16.97056 C45.8667,18.40696 46.7388,19.44322 48.05208,19.44322 C49.3551,19.44322 50.2272,18.3967 50.2272,16.97056 C50.2272,15.54442 49.3551,14.4979 48.05208,14.4979 C46.7388,14.4979 45.8667,15.53416 45.8667,16.97056 Z M53.35308,20.5 L53.35308,13.44112 L56.39004,13.44112 C58.07268,13.44112 59.00634,14.3953 59.00634,15.77014 C59.00634,17.1655 58.07268,18.1915 56.39004,18.1915 L54.72792,18.1915 L54.72792,20.5 L53.35308,20.5 Z M56.26692,14.5492 L54.72792,14.5492 L54.72792,17.08342 L56.26692,17.08342 C57.15954,17.08342 57.61098,16.53964 57.61098,15.79066 C57.61098,15.05194 57.15954,14.5492 56.26692,14.5492 Z M62.3784599,20.5 L63.7635599,20.5 L63.7635599,17.75032 L66.4003799,13.44112 L64.9434599,13.44112 L63.1171799,16.47808 L63.0761399,16.47808 L61.3421999,13.44112 L59.7826799,13.44112 L62.3784599,17.79136 L62.3784599,20.5 Z M69.6972599,14.59024 L72.0878399,14.59024 L72.0878399,20.5 L73.4626799,20.5 L73.4626799,14.59024 L75.8532599,14.59024 L75.8532599,13.44112 L69.6972599,13.44112 L69.6972599,14.59024 Z M77.1938999,20.5 L78.5687399,20.5 L78.5687399,17.51434 L81.8929799,17.51434 L81.8929799,20.5 L83.2678199,20.5 L83.2678199,13.44112 L81.8929799,13.44112 L81.8929799,16.3447 L78.5687399,16.3447 L78.5687399,13.44112 L77.1938999,13.44112 L77.1938999,20.5 Z M85.3574399,20.5 L86.7322799,20.5 L86.7322799,13.44112 L85.3574399,13.44112 L85.3574399,20.5 Z M88.5038398,18.48904 C88.5038398,19.80232 89.5093198,20.62312 91.3663798,20.62312 C93.2644798,20.62312 94.3315198,19.72024 94.3315198,18.3967 C94.3315198,16.91926 93.1413598,16.57042 92.0127598,16.36522 L91.5407998,16.28314 C90.6994798,16.1395 89.9915398,15.96508 89.9915398,15.30844 C89.9915398,14.67232 90.5968798,14.344 91.3868998,14.344 C92.1769198,14.344 92.7617398,14.7031 92.7617398,15.34948 L94.1057998,15.34948 C94.1057998,14.10802 93.0387598,13.318 91.3868998,13.318 C89.6939998,13.318 88.6166998,14.23114 88.6166998,15.44182 C88.6166998,16.97056 89.8889398,17.28862 91.0483198,17.48356 L91.5202798,17.56564 C92.2897798,17.70928 92.9258998,17.90422 92.9258998,18.53008 C92.9258998,19.20724 92.3513398,19.59712 91.3663798,19.59712 C90.4532398,19.59712 89.8478998,19.1662 89.8478998,18.48904 L88.5038398,18.48904 Z M98.4081598,16.97056 C98.4081598,19.07386 99.7316998,20.62312 101.90682,20.62312 C103.65102,20.62312 104.78988,19.66894 105.05664,18.17098 L103.6818,18.17098 C103.45608,18.99178 102.92256,19.44322 101.92734,19.44322 C100.6551,19.44322 99.8240398,18.3967 99.8240398,16.97056 C99.8240398,15.51364 100.63458,14.4979 101.92734,14.4979 C102.861,14.4979 103.45608,14.94934 103.6818,15.77014 L105.05664,15.77014 C104.78988,14.27218 103.67154,13.318 101.92734,13.318 C99.7829998,13.318 98.4081598,14.88778 98.4081598,16.97056 Z M106.40754,16.97056 C106.40754,14.86726 107.82342,13.318 110.0088,13.318 C112.15314,13.318 113.5998,14.86726 113.5998,16.97056 C113.5998,19.07386 112.15314,20.62312 110.0088,20.62312 C107.82342,20.62312 106.40754,19.07386 106.40754,16.97056 Z M107.82342,16.97056 C107.82342,18.40696 108.69552,19.44322 110.0088,19.44322 C111.31182,19.44322 112.18392,18.3967 112.18392,16.97056 C112.18392,15.54442 111.31182,14.4979 110.0088,14.4979 C108.69552,14.4979 107.82342,15.53416 107.82342,16.97056 Z M115.3098,20.5 L115.3098,13.44112 L117.8235,13.44112 C120.29616,13.44112 121.5684,14.92882 121.5684,16.97056 C121.5684,19.0123 120.29616,20.5 117.8235,20.5 L115.3098,20.5 Z M117.73116,14.57998 L116.68464,14.57998 L116.68464,19.36114 L117.73116,19.36114 C119.49588,19.36114 120.15252,18.25306 120.15252,16.97056 C120.15252,15.68806 119.49588,14.57998 117.73116,14.57998 Z M123.2784,20.5 L128.49048,20.5 L128.49048,19.36114 L124.65324,19.36114 L124.65324,17.44252 L127.66968,17.44252 L127.66968,16.35496 L124.65324,16.35496 L124.65324,14.57998 L128.39814,14.57998 L128.39814,13.44112 L123.2784,13.44112 L123.2784,20.5 Z"
                      id="COPY-THIS-CODE"
                      fill="#FFF"
                    />
                    <path
                      d="M28.25,20.0000937 L27.5,20.0000937 L27.5,19.2497422 L27.875,19.2497422 C28.082,19.2497422 28.25,19.0819349 28.25,18.8751289 L28.25,12.1253398 C28.25,11.9183463 28.082,11.7501641 27.875,11.7501641 L21.125,11.7501641 C20.918,11.7501641 20.75,11.9181588 20.75,12.1253398 L20.75,12.4999531 L20,12.4999531 L20,11.7501641 C20,11.3356145 20.3358125,11 20.75,11 L28.25,11 C28.6641875,11 29,11.3356145 29,11.7501641 L29,19.2497422 C29,19.6641042 28.664,20.0000937 28.25,20.0000937 L28.25,20.0000937 Z M26.75,14.0000937 L26.75,22.2500234 C26.75,22.664198 26.4141875,23 26,23 L17.75,23 C17.3358125,23 17,22.664198 17,22.2500234 L17,14.0000937 C17,13.5857317 17.3358125,13.2501172 17.75,13.2501172 L26,13.2501172 C26.414,13.2501172 26.75,13.5857317 26.75,14.0000937 L26.75,14.0000937 Z M25.625,14.0000937 L18.125,14.0000937 C17.918,14.0000937 17.75,14.1684635 17.75,14.375082 L17.75,21.8746602 C17.75,22.0822162 17.918,22.2500234 18.125,22.2500234 L25.625,22.2500234 C25.832,22.2500234 26,22.0822162 26,21.8746602 L26,14.375082 C26,14.168651 25.832,14.0000937 25.625,14.0000937 L25.625,14.0000937 Z"
                      id="Shape"
                      stroke="#FFF"
                      strokeWidth=".25"
                      fill="#FFF"
                    />
                  </g>
                </g>
                <rect id="Rectangle-3" fill="#2F383D" y="68" width="410" height="399" />
                <path
                  d="M0,71.1924325 C0,69.533955 1.34831184,68.1894934 2.99619829,68.1894934 L58,68.1894934 L58,466.189493 L2.99619829,466.189493 C1.34144367,466.189493 0,464.845566 0,463.186554 L0,71.1924325 Z"
                  id="Rectangle-696"
                  fill="#1D2326"
                  opacity=".468"
                />
                <text
                  id="01-02-03-04-05-06-07"
                  opacity=".2"
                  fontFamily=".AppleSystemUIFont"
                  fontSize="14.4"
                >
                  <tspan x="20" y="102.606" fill="#FFF">01</tspan>
                  <tspan x="20" y="133.006" fill="#FFF">02</tspan>
                  <tspan x="20" y="163.406" fill="#FFF">03</tspan>
                  <tspan x="20" y="193.806" fill="#FFF">04</tspan>
                  <tspan x="20" y="224.206" fill="#FFF">05</tspan>
                  <tspan x="20" y="254.606" fill="#FFF">06</tspan>
                  <tspan x="20" y="285.006" fill="#FFF">07</tspan>
                  <tspan x="20" y="315.406" fill="#FFF">08</tspan>
                  <tspan x="20" y="345.806" fill="#FFF">09</tspan>
                  <tspan x="20" y="376.206" fill="#FFF">10</tspan>
                  <tspan x="20" y="406.606" fill="#FFF">11</tspan>
                  <tspan x="20" y="437.006" fill="#FFF">12</tspan>
                </text>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <div className="code-wrapper">
      <pre>
        <p className="script-tag">{line1}<span>{line1_2}</span>{line1_3}</p>
        <p className="script-tag">{line2}<span>{line2_2}</span>{line2_3}</p>
        <p className="var-line">{line3}<span> {line3_2}</span> {line3_3}<span> {line3_4}</span></p>
        <p className> </p>
        <p className="function-line">{line4}<span>{line4_2}</span></p>
        <p className="simple-line">{line5}</p>
        <p className="simple-line">{line5_2}</p>
        <p className="simple-line">{line5_3}</p>
        <p className="simple-line">{line5_4}</p>
        <p className="simple-line">{line5_5}</p>
        <p className="simple-line">{line5_6}</p>
        <p className="simple-line">{line5_7}</p>
        <p className="simple-line">{line6}</p>
        <p className="script-tag">{line7}</p>
        <p className="html-script-tag">
          {line8}<span>{line8_2}</span>{line8_3}<span>{line8_4}</span>{line8_5}
        </p>
      </pre>
      <div className="select-copy-overlay" />
    </div>
  </div>;

export default SdkPicker3;



// WEBPACK FOOTER //
// ./src/components/OnboardingFlow/svg/SdkPicker3.js